var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "app", class: _vm.getAppClass, attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            {
              attrs: { id: "full-loading" },
              on: {
                wheel: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-loading" }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.getLoadingText))])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.picMaskShow
            ? _c("pic-mask", {
                attrs: { imgSrc: _vm.activeImgSrc, imgDeg: _vm.activeImgDeg },
                on: {
                  closePicMask: function($event) {
                    _vm.picMaskShow = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 